var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("成绩查询")]),_c('a-divider'),_c('iframe',{attrs:{"width":"100%","height":"800px","src":"/cert/score.html","frameborder":"no"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }